import {
  Component,
  OnInit,
  Inject,
  ViewChild,
  ElementRef,
  AfterViewInit,
  NgZone,
} from "@angular/core";
import Swal from "sweetalert2";
import swal from "sweetalert2";
import { HttpErrorResponse } from "@angular/common/http";
import { ActivatedRoute, Router } from "@angular/router";
import { Spinkit } from "ng-http-loader";
import { HttpService } from "../../services/http/http.service";
import { LoginService } from "src/app/layout/components/login-form/login-form.service";
import { isNullOrUndefined } from "util";
import { environment } from "../../../environments/environment";
import {
  MatBottomSheet,
  MatBottomSheetRef,
  MAT_BOTTOM_SHEET_DATA,
} from "@angular/material/bottom-sheet";
import { MapsAPILoader } from "@agm/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import {
  GoogleLoginProvider,
  FacebookLoginProvider,
} from "angularx-social-login";
import { SocialUser } from "angularx-social-login";
import { SocialAuthService } from "angularx-social-login";
import { interval } from "rxjs";

declare var FB: any;

@Component({
  selector: "resto",
  templateUrl: "./resto-page.component.html",
  styleUrls: ["./resto-page.component.scss"],
})
export class RestoPageComponent implements OnInit {
  UserCondition;
  decode;
  id;
  restoCondition;
  restoConditionAll;
  decodetableID;
  tableID;
  searchText;
  allrestaurant = [];
  delivery_Status;
  restaurant_online_status;
  public spinkit = Spinkit;
  cookie_value;
  imageLink;
  restaurant_coupan_status;
  restaurant_coupan_value;
  restaurant_verified: any;
  lat;
  google: any;
  lng;
  geoCoder;
  encodeUrl_origin;
  encodeUrl_destination;
  currentLocation;
  address;
  lat_resto;
  lng_resto;
  restoId;
  longitude;
  latitude;
  panelOpenState = false;
  qrWebFlagNonUser: boolean = false
  flag = false;

  constructor(
    public httpSv: HttpService,
    private router: Router,
    private loginService: LoginService,
    private route: ActivatedRoute,
    private _bottomSheet: MatBottomSheet,
    private mapsAPILoader: MapsAPILoader,
    private _snackBar: MatSnackBar,
    private ngZone: NgZone
  ) { }

  ngOnInit() {
    this.cookie_value = sessionStorage.getItem("cookie");
    this.route.queryParams.subscribe((params) => {
      this.UserCondition = params["id"];
      if (this.UserCondition) {
        this.decode = atob(this.UserCondition);
        sessionStorage.setItem("restoId", this.decode);
        sessionStorage.setItem("restoIDCopy", this.decode);

        sessionStorage.setItem("restoIds", this.UserCondition);

      }
    });
    this.route.queryParams.subscribe((params) => {
      console.log(params);

      let claimId = params["restaurant_id"];
      if (claimId) {
        let dcode = atob(claimId);
        sessionStorage.setItem("claim_id", dcode);
      }
      this.tableID = params["table_id"];
      this.UserCondition = params["id"];
      if (this.tableID && this.UserCondition) {
        this.decode = atob(this.UserCondition);
        this.decodetableID = atob(this.tableID);
        sessionStorage.setItem("tableId", this.decodetableID);
        sessionStorage.setItem("tableIds", this.tableID);
        sessionStorage.setItem("restoId", this.decode);
        sessionStorage.setItem("restoIDCopy", this.decode);
        sessionStorage.setItem("restoIds", this.UserCondition);
        if (!sessionStorage.getItem('access_token')) {
          this.qrWebFlagNonUser = true
        }

      }
    });

    this.restoCondition = "1";

    if (this.cookie_value != "Accepted") {
      this.openBottomSheetCookies();
    }
    this.longitude = sessionStorage.getItem("lng");
    this.latitude = sessionStorage.getItem("lat");
  }
  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
    if (this.qrWebFlagNonUser) {
      this.router.navigate(['/public/food-menu'])
      sessionStorage.setItem('qrCode', 'true')
    }
    else if (sessionStorage.getItem('access_token')) {
      sessionStorage.setItem('qrCode', 'true')
      this.router.navigate(['/horizontal/food-menu'])
    }
  }
  web_site;
  name;
  zip_code;
  zoom;

  onLink(id, tableid, visitor_origin) {
    sessionStorage.setItem("restoId", id);
    sessionStorage.setItem("restoIDCopy", id);
    sessionStorage.setItem("visitor_origin", visitor_origin);
    let Baselink = environment.linkUrl + "?id=" + id + "&table_id=" + tableid;
    window.location.href = Baselink;
    window.location.reload();
  }

  trackvisitor() {
    this.id = sessionStorage.getItem("restoId");
    this.loginService.trackVisitor(this.id).subscribe((response) => {
      if (response["status"] == true) {
      }
    });
  }

  changeLocation() {
    this.restoCondition = "6";
    this.router.navigate(["/public/user-location"]);
  }

  images = [
    { path: "https://source.unsplash.com/800x600/?nature" },
    { path: "https://source.unsplash.com/800x600/?car" },
    { path: "https://source.unsplash.com/800x600/?moto" },
    { path: "https://source.unsplash.com/800x600/?fantasy" },
  ];

  userCurrentLocation;
  getOfflineRestaurant() {
    if (this.latitude && this.longitude) {
      this.httpSv
        .getAllOfflineRestaurants(this.latitude, this.longitude)
        .subscribe(
          (res: any) => {
            if (res["status"] == "TRUE") {
              this.userCurrentLocation = res.result.data[0].visitorOrigin;
              this.restoCondition = "2";
              this.allrestaurant = res["result"].data;
              this.restoOne = this.allrestaurant.slice(0, 1);
              this.restoTwo = this.allrestaurant.slice(1, 2);
            }
          },
          (err: any) => {
            console.log(err);
          }
        );
    } else {
      this.httpSv.getRestoWithoutLocation().subscribe(
        (res: any) => {
          if (res["status"] == "TRUE") {
            this.restoCondition = "2";
            this.allrestaurant = res["result"].data;
            this.restoOne = this.allrestaurant.slice(0, 1);
            this.restoTwo = this.allrestaurant.slice(1, 2);
            this.userCurrentLocation = res.result.data[0].visitorOrigin;
          }
        },
        (err: any) => {
          console.log(err);
        }
      );
    }
  }

  cuisineArray = [];
  cuisineImages = [];
  getAllCuisines() {
    this.httpSv.getAllCuisines().subscribe(
      (res: any) => {
        this.cuisineArray = res["result"].data;
        this.cuisineImages = this.cuisineArray.map((item) => ({
          path: item.image,
          index: 5,
        }));
      },
      (err: any) => {
        console.log(err);
      }
    );
  }

  cuisineImagess(e, vl) {
    console.log(e);
    console.log(vl);
  }

  getCategoryFilter(catId) {
    if (this.latitude && this.longitude) {
      this.httpSv
        .getAllFilteredCategories(this.latitude, this.longitude, catId)
        .subscribe(
          (res: any) => {
            this.allrestaurant = res["result"].data;
            this.showAllResto = true;
          },
          (err: any) => {
            console.log(err);
            this.showAllResto = false;
            this._snackBar.open("No Restaurants Found!");
            setTimeout(() => {
              this._snackBar.dismiss();
            }, 2000);
          }
        );
    } else {
      this.httpSv.getFilteredCategories(catId).subscribe(
        (res: any) => {
          this.allrestaurant = res["result"].data;
          this.showAllResto = true;
        },
        (err: any) => {
          console.log(err);
          this.showAllResto = false;
          this._snackBar.open("No Restaurants Found!");
          setTimeout(() => {
            this._snackBar.dismiss();
          }, 2000);
        }
      );
    }
  }

  getCuisineFilter(cuisineId) {
    if (this.latitude && this.longitude) {
      this.httpSv
        .getAllFilteredCuisine(this.latitude, this.longitude, cuisineId)
        .subscribe(
          (res: any) => {
            this.allrestaurant = res["result"].data;
            this.showAllResto = true;
          },
          (err: any) => {
            console.log(err);
            this.showAllResto = false;
            this._snackBar.open("No Restaurants Found!");
            setTimeout(() => {
              this._snackBar.dismiss();
            }, 2000);
          }
        );
    } else {
      this.httpSv.getFilteredCusine(cuisineId).subscribe(
        (res: any) => {
          this.allrestaurant = res["result"].data;
          this.showAllResto = true;
        },
        (err: any) => {
          console.log(err);
          this.showAllResto = false;
          this._snackBar.open("No Restaurants Found!");
          setTimeout(() => {
            this._snackBar.dismiss();
          }, 2000);
        }
      );
    }
  }

  gotoResto() {
    this.showAllResto = false;
  }

  goToSearchPage() {
    this.restoCondition = "4";
  }
  gotoRestos() {
    this.restoCondition = "2";
    this.searchText = "";
    this.showFilteredResto = false;
  }
  gotoRestoPage() {
    this.restoCondition = "2";
    this.panelOpenState = false;
  }

  showFilteredResto: boolean = false;
  checkFiletered(e) {
    if (e.length >= 3) {
      this.showFilteredResto = true;
    } else {
      this.showFilteredResto = false;
    }
  }

  openLocationMap() {
    this.restoCondition = "5";
    let data = {
      userCurrentLocation: this.userCurrentLocation,
    };

    let sheetRef = this._bottomSheet.open(BottomSheetUserLocation, {
      data: data,
      disableClose: true,
    });

    sheetRef.afterDismissed().subscribe((dataFromChild) => {
      this.restoCondition = "6";
    });
  }

  confirmLocation() { }
  markerDragEnd($event: MouseEvent) {
    console.log($event);
  }

  restoCheck() {
    this.loginService.restoCheck(this.decode).subscribe(
      (response) => {
        if (response["status"] == true) {
          this.imageLink = response["result"].data.restaurant_image;
          this.restaurant_verified =
            response["result"].data.restaurant_verified;
          this.restaurant_online_status =
            response["result"].data.restaurant_online_status;
          sessionStorage.setItem("onlineStatus", this.restaurant_online_status);
          this.restoCondition = "1";
          this.trackvisitor();
          this.lat_value = sessionStorage.getItem("lat");
          this.lng_value = sessionStorage.getItem("lng");
          this.visitor_origin = sessionStorage.getItem("visitor_origin");

          if (this.lat_value && this.lng_value) {
            this.httpSv
              .recordLocation_guest(
                this.decode,
                this.lat_value,
                this.lng_value,
                this.visitor_origin
              )
              .subscribe((res) => {
                if (res["status"] == true) {
                }
              });
          }
        }
        if (response["status"] == false) {
          this.restoCondition = "1";
        }
      },
      (err: HttpErrorResponse) => {
        this.restoCondition = "2";
      }
    );
  }
  lat_value;
  lng_value;
  visitor_origin;
  restoCheckTable() {
    this.loginService
      .restoCheckTable(this.decode, this.decodetableID)
      .subscribe(
        (response) => {
          if (response["status"] == true) {
            this.imageLink = response["result"].data.restaurant_image;
            this.delivery_Status =
              response["result"].data.restaurant_delivery_status;
            this.restaurant_online_status =
              response["result"].data.restaurant_online_status;
            this.restaurant_coupan_status =
              response["result"].data.restaurant_coupan_status;
            this.restaurant_coupan_value =
              response["result"].data.restaurant_coupan_value;
            sessionStorage.setItem("onlineStatus", this.restaurant_online_status);
            this.restoCondition = "1";
            this.trackvisitor();
            this.lat_value = sessionStorage.getItem("lat");
            this.lng_value = sessionStorage.getItem("lng");
            this.visitor_origin = sessionStorage.getItem("visitor_origin");
            if (this.lat_value && this.lng_value) {
              this.httpSv
                .recordLocation_guest(
                  this.decode,
                  this.lat_value,
                  this.lng_value,
                  this.visitor_origin
                )
                .subscribe((res) => {
                  if (res["status"] == true) {
                  }
                });
            }
          }
          if (response["status"] == false) {
            this.restoCondition = "2";
          }
        },
        (err: HttpErrorResponse) => {
          this.restoCondition = "2";
        }
      );
  }
  openBottomSheetCookies(): void {
    this._bottomSheet.open(BottomSheetOverviewCookies, {
      disableClose: true,
    });
  }
  restoOne = [];
  restoTwo = [];
  getLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position: Position) => {
          if (position) {
            this.lat = position.coords.latitude;
            this.lng = position.coords.longitude;

            sessionStorage.clear();
            sessionStorage.setItem("lat", this.lat);
            sessionStorage.setItem("lng", this.lng);
            this.httpSv.getAllOfflineRestaurants(this.lat, this.lng).subscribe(
              (res: any) => {
                if (res["status"] == "TRUE") {
                  this.restoCondition = "2";
                  this.allrestaurant = res["result"].data;
                  this.restoOne = this.allrestaurant.slice(0, 1);
                  this.restoTwo = this.allrestaurant.slice(1, 2);
                  this.userCurrentLocation = res.result.data[0].visitorOrigin;
                }
              },
              (err: any) => {
                console.log(err);
              }
            );
          }
        },
        (error: PositionError) => {
          this.getOfflineRestaurant();
        }
      );
    } else {
      swal.fire("Geolocation is not supported by this browser.");
    }
  }

  showAllResto: boolean = false;
  showAllRestos() {
    this.showAllResto = true;
  }
  get_direction(id, lat_value, lng_value, origin, destination): void {
    this.restoId = atob(id);
    this.lat_resto = parseFloat(lat_value);
    this.lng_resto = parseFloat(lng_value);
    this.encodeUrl_origin = encodeURI(origin);
    if (!destination && destination != "undefine") {
      this.geoCoder.geocode(
        { location: { lat: this.lat_resto, lng: this.lng_resto } },
        (results, status) => {
          if (results[0]) {
            this.address = results[0].formatted_address;
            this.encodeUrl_destination = encodeURI(this.address);
            window.open(
              environment.googleDirectionKey +
              "origin=" +
              this.encodeUrl_origin +
              "&destination=" +
              this.encodeUrl_destination
            );
            this.httpSv
              .recordDestination_guest(this.restoId, this.address)
              .subscribe((res) => {
                if (res["status"] == true) {
                }
              });
          } else {
            window.alert("No results found.");
          }
        }
      );
    } else {
      this.encodeUrl_destination = encodeURI(destination);
      window.open(
        environment.googleDirectionKey +
        "origin=" +
        this.encodeUrl_origin +
        "&destination=" +
        this.encodeUrl_destination
      );
    }
  }

  onClikOtp(): void {
    let otpBottomsheet = this._bottomSheet.open(BottomSheetOverviewOtp, {
      disableClose: true,
    });
    otpBottomsheet.afterDismissed().subscribe((data) => {
      if (data == "showMenu") {
        this.router.navigate(["/horizontal/aggregator"]);
        this.restoCondition = "2";
        this.getCategory();
        this.getAllCuisines();
        this.getOfflineRestaurant();
      } else {
        this.restoCondition = "1";
      }
    });

    let temp = document.getElementById("googleLOGINIcon");
    // temp.classList.add("googleBtn-toggle");
    document.getElementById("googleLoginIcon").appendChild(temp);
  }

  goToSeeMenu() {
    this.router.navigate(["/public/aggregator"]);
  }

  categoryArray: any[] = [];
  getCategory() {
    this.httpSv.getAllCategories().subscribe(
      (res: any) => {
        this.categoryArray = res.result.data;
      },
      (err: any) => {
        console.log(err);
      }
    );
  }
}

@Component({
  selector: "bottom-sheet-overview-cookies",
  templateUrl: "bottom-sheet-overview-cookies.html",
})
export class BottomSheetOverviewCookies implements OnInit {
  cookie: string = "NotAccepted";
  showmore: boolean = false;
  clickinfo: boolean = true;

  expirationInMin;
  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private bottomSheetRef: MatBottomSheetRef<BottomSheetOverviewCookies>,
    private router: Router,
    public httpSv: HttpService
  ) { }
  onAccept() {
    this.cookie = "Accepted";
    sessionStorage.setItem("cookie", this.cookie);
    this.bottomSheetRef.dismiss();
  }
  moreInfo() {
    this.showmore = true;
    this.clickinfo = false;
  }
  ngOnInit() { console.log('2') }
  onprivacy() {
    this.router.navigate(["/public/privacy"]);
  }
}

@Component({
  selector: "bottom-sheet-overview-otp",
  templateUrl: "bottom-sheet-overview-otp.html",
})
export class BottomSheetOverviewOtp implements OnInit {
  cookie: string = "NotAccepted";
  showmore: boolean = false;
  clickinfo: boolean = true;
  showVerifyOtp: boolean = false;
  getOtpForm: FormGroup;
  getnameForm: FormGroup;
  expirationInMin;
  email;
  showEmail: boolean = true;
  otpResponse: any;
  userName;
  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private bottomSheetRef: MatBottomSheetRef<BottomSheetOverviewOtp>,
    private router: Router,
    public httpSv: HttpService,
    private authService: SocialAuthService,
    private _bottomSheet: MatBottomSheet,
    private loginService: LoginService,
    private _snackBar: MatSnackBar
  ) { }

  user: SocialUser;
  loggedIn: boolean;
  ngOnInit() {
    this.authService.authState.subscribe((user) => {
      this.user = user;
      console.log('3')
      // this.loggedIn = (user != null);
    });

    this.otpForm();
    this.UserNameForm();
  }

  otpForm() {
    this.getOtpForm = new FormGroup({
      userEmail: new FormControl("", [
        Validators.required,
        Validators.pattern(
          "^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,4}$"
        ),
      ]),
    });
  }

  UserNameForm() {
    this.getnameForm = new FormGroup({
      userName: new FormControl("", [Validators.required]),
    });
  }

  Privacy() {
    this.closeModal();
    this.router.navigate(["/public/privacy"]);
  }
  terms() {
    this.closeModal();
    this.router.navigate(["/public/terms"]);
  }
  closeModal() {
    this.bottomSheetRef.dismiss();
  }
  close_popup() {
    this.bottomSheetRef.dismiss();
    let temp = document.getElementById("googleLOGINIcon");
    // temp.classList.remove("googleBtn-toggle");
    document.getElementById("googleIconContainer").appendChild(temp);
  }

  userEmailStored;
  is_new_user;
  submitted: boolean = false;
  sendOtpByEmail() {
    this.submitted = true;
    if (this.getOtpForm.valid) {
      //removing the google icon
      let temp = document.getElementById("googleLOGINIcon");
      // temp.classList.remove("googleBtn-toggle");
      document.getElementById("googleIconContainer").appendChild(temp);

      this.showEmail = !this.showEmail;
      sessionStorage.removeItem("access_token");
      this.userEmailStored = this.getOtpForm.value.userEmail;
      this.httpSv
        .sendOtpByEmail(this.getOtpForm.value.userEmail)
        .subscribe((res: any) => {
          if (res["status"] == "TRUE") {
            const b64 = res.result.data; // base64 string
            const decodedStr = atob(b64); // -> JSON string (if it was encoded as plain ASCII/UTF-8)
            const decodedObj = JSON.parse(decodedStr);

            this.otpResponse = decodedObj.otp;
            // this.otpResponse = res.result.data.otp;
          } else {
          }
        });
    } else {
    }
  }

  get_OTP(value) { }

  restoCondition;
  authToken;
  hideVerifyOTP: boolean = false;
  showErrorMessage: boolean = false;
  showNameScreen: boolean = false;
  notShow: boolean = false;
  verifyOtp(e) {
    if (this.otpResponse == parseInt(this.otpValue)) {
      let otpObj = {
        email: this.getOtpForm.value.userEmail,
        otp: this.otpValue,
      };
      this.httpSv.verifyOTPUser(otpObj).subscribe((res: any) => {
        if (res["status"] == "TRUE") {
          this.closeModal();
          if (res.result.userDetails.name == null) {
            this.authToken = res.result.token;
            sessionStorage.setItem("access_token", this.authToken);
            this.userEmails = res.result.userDetails.email;
            sessionStorage.setItem("email", this.userEmails);
            this._bottomSheet.open(BottomSheetProfileUpdate, {
              disableClose: true,
            });
          } else {
            this.authToken = res.result.token;
            sessionStorage.setItem("access_token", this.authToken);
            this.userNames = res.result.userDetails.name;
            sessionStorage.setItem("userName", this.userNames);
            this.userEmails = res.result.userDetails.email;
            sessionStorage.setItem("email", this.userEmails);
            if (this.authToken) {
              this.bottomSheetRef.dismiss("showMenu");
            }
          }
        } else {
        }
      });
    } else {
      this.showErrorMessage = true;
    }
  }

  otpValue;
  onOtpChange(e) {
    if (e.length == 4) {
      this.otpValue = e;
      this.verifyOtp(e);
    }
  }

  resendOtp() {
    this.showEmail = !this.showEmail;
    this.sendOtpByEmail();
  }

  userNames;
  userEmails;
  userEmailSplitted;
  get f() {
    return this.getOtpForm.controls;
  }

  signInWithGoogle(): void {
    this.authService.signIn(GoogleLoginProvider.PROVIDER_ID).then((x) => {
      console.log(x);
    });
  }

  fbData;
  async signInWithFB() {
    FB.login(
      async function (response) {
        //Checking the login is successfully done or not
        if (response.authResponse) {
          // Calling another facebook api for getting the data of user and storing the data in local storage
          FB.api(
            "/me",
            { locale: "en_US", fields: "name, email" },
            function (response) {
              // if facebook account does not have email associated with the account setting it to null
              sessionStorage.setItem(
                "fb_email",
                response["email"] ? response["email"] : "null"
              );
              sessionStorage.setItem("fb_userName", response["name"]);
            }
          );
        }
      },

      { scope: "public_profile,email" }
    );
    // Using setTimeout for calling our socialLogin api in synchronous manner
    // await setTimeout(() => {
    //   let fbUserEmail = sessionStorage.getItem("fb_email");
    //   let fbUserName = sessionStorage.getItem("fb_userName");
    //   let fbObj = {
    //     email: fbUserEmail,
    //     name: fbUserName,
    //     source: "Facebook",
    //   };
    //   // If email is null, declining the login with a notification else calling our api
    //   if (fbObj.email == "null") {
    //     this._snackBar.open("Can't proceed with Facebook.Try different way");
    //     setTimeout(() => {
    //       this._snackBar.dismiss();
    //     }, 3000);
    //     FB.logout(function (response) {});
    //   } else if(sessionStorage.getItem("email")) {
    //     this.loginService.postLoginSocial(fbObj).subscribe(
    //       (response) => {
    //         if (response["status"] == true) {
    //           this.authToken = response.result.authToken;
    //           sessionStorage.setItem("access_token", this.authToken);
    //           this.router.navigate(["/horizontal/aggregator"]);
    //         }
    //       },
    //       (err: any) => {
    //         console.log("Facebook configuration error:", err);
    //       }
    //     );
    //   }
    // }, 1200);
    await this.loginByFacebook()
  }
  loginByFacebook() {

    let data = interval(1000).subscribe(() => {
      let flag = sessionStorage.getItem("fb_userName")
      if (flag) {

        data.unsubscribe()
        let fbUserEmail = sessionStorage.getItem("fb_email");
        let fbUserName = sessionStorage.getItem("fb_userName");
        let fbObj = {
          email: fbUserEmail,
          name: fbUserName,
          source: "Facebook",
        };
        // If email is null, declining the login with a notification else calling our api
        console.log(sessionStorage.getItem("email"))
        if (fbObj.email == "null") {
          this._snackBar.open("Can't proceed with Facebook.Try different way");
          setTimeout(() => {
            this._snackBar.dismiss();
          }, 3000);
          FB.logout(function (response) { });
        } else if (sessionStorage.getItem("fb_email")) {
          this.loginService.postLoginSocial(fbObj).subscribe(
            (response) => {
              if (response["status"] == true) {
                this.authToken = response.result.authToken;
                sessionStorage.setItem("access_token", this.authToken);
                this.router.navigate(["/horizontal/aggregator"]);
              }
            },
            (err: any) => {
              console.log("Facebook configuration error:", err);
            }
          );
        }
        data.unsubscribe()
      }
      else if (sessionStorage.getItem("access_token")) {
        data.unsubscribe();
      } else {
      }
    })
  }
}

@Component({
  selector: "bottom-sheet-profile-update",
  templateUrl: "bottom-sheet-profile-update.html",
})
export class BottomSheetProfileUpdate implements OnInit {
  getProfileForm: FormGroup;
  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private bottomSheetRef: MatBottomSheetRef<BottomSheetProfileUpdate>,
    private router: Router,
    public httpSv: HttpService
  ) { }

  ngOnInit() {
    this.profileForm();
    console.log('4')
  }

  profileForm() {
    this.getProfileForm = new FormGroup({
      userName: new FormControl("", [Validators.required]),
    });
  }
  closeModal() {
    this.bottomSheetRef.dismiss();
  }
  close_popup() {
    this.bottomSheetRef.dismiss();
  }

  userNames;
  updateUserProfile() {
    let profileObj = {
      name: this.getProfileForm.value.userName,
    };
    this.httpSv.updateProfile(profileObj).subscribe(
      (res: any) => {
        if (res["status"] == "TRUE") {
          this.closeModal();
          sessionStorage.setItem("userName", this.getProfileForm.value.userName);
          this.router.navigate(["/horizontal/aggregator"]);
        } else {
        }
      },
      (err: any) => {
        console.log(err);
      }
    );
  }

  get f() {
    return this.getProfileForm.controls;
  }
}

@Component({
  selector: "bottom-sheet-user-location",
  templateUrl: "bottom-sheet-user-location.html",
})
export class BottomSheetUserLocation implements OnInit {
  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private bottomSheetRef: MatBottomSheetRef<BottomSheetUserLocation>,
    private router: Router,
    public httpSv: HttpService
  ) { }

  location;
  restoCondition;
  ngOnInit() {
    this.location = this.data.userCurrentLocation;
    console.log('5')
  }

  changeLocation() {
    this.restoCondition = "6";
    this.bottomSheetRef.dismiss(this.restoCondition);
    this.router.navigate(["/public/user-location"]);
  }
  confirmLocation() {
    this.bottomSheetRef.dismiss();
  }
}
